import http from '../../../../../../libs/http'

const api = `${process.env.VUE_APP_MICROSERVICE_API_COMMON}`

const list = (query = {}) => http.get(`${api}/department`, { params: { ...query } })

export default list
